import { TextField } from '@mui/material';
import { styled } from '@mui/system';

export const CssTextField = styled(TextField)(({ theme }) => ({
  '& .MuiOutlinedInput-root': {
    '& fieldset': {
      borderColor: theme.palette.primary.light
    },
    '&:hover fieldset': {
      borderColor: theme.palette.primary.main
    },
    '&.Mui-focused fieldset': {
      borderColor: theme.palette.primary.dark
    }
  },
  '& .MuiInputLabel-root.Mui-focused': {
    color: theme.palette.primary.main
  },
  '& .MuiInput-underline:after': {
    borderBottomColor: theme.palette.primary.main
  }
}));
